import { render, staticRenderFns } from "./TabChangePassword.vue?vue&type=template&id=7086705f&scoped=true"
import script from "./TabChangePassword.vue?vue&type=script&lang=js"
export * from "./TabChangePassword.vue?vue&type=script&lang=js"
import style0 from "./TabChangePassword.vue?vue&type=style&index=0&id=7086705f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7086705f",
  null
  
)

export default component.exports